import { Component, OnDestroy, OnInit } from '@angular/core';
import { DataTableDirective } from '../../../../shared/directives/data-table.directive';
import { AsyncValidatorFn, FormBuilder } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { ColumnConfig } from '../../../../shared/models/column-config.model';
import { AuthService } from '../../../../shared/services/auth.service';
import { NotificationService } from '../../../../shared/services/notification.service';
import { PageStateManagerService } from '../../../../shared/services/page-state-manager.service';
import { TitleService } from '../../../../shared/services/title.service';
import { User } from '../../models/user.model';
import { UserService } from '../../services/user.service';
import { Validators } from '@angular/forms';
import { existsValidator } from '../../../../shared/validators/exists.validator';


@Component({
  selector: 'app-user-management',
  standalone: false,
  templateUrl: './user-management.component.html',
})
export class UserManagementComponent extends DataTableDirective<User> implements OnInit, OnDestroy {
  override modelName: string = 'User';
  override columns: ColumnConfig[] = [];
  private readonly createPasswordColumn: ColumnConfig = {
    name: 'password',
    label: 'Password',
    inputType: 'new-password',
    validators: [
      Validators.required,
      Validators.minLength(8),
      Validators.maxLength(30),
      Validators.pattern(/^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[^A-Za-z0-9\s])[\S]{8,30}$/)
    ],
    errorMessages: {
      required: 'Password is required',
      minlength: 'Password must be at least 8 characters long',
      maxlength: 'Password cannot be more than 30 characters long',
      pattern: 'Password must contain at least one uppercase letter, one lowercase letter, one number, and one special character and cannot contain spaces'
    }
  };

  constructor(
    private userService: UserService,
    fb: FormBuilder,
    route: ActivatedRoute,
    router: Router,
    titleService: TitleService,
    notificationService: NotificationService,
    pageStateManager: PageStateManagerService,
    authService: AuthService,
  ) {
    super(
      userService,
      fb,
      route,
      router,
      titleService,
      notificationService,
      pageStateManager,
      authService
    );
  }

  override ngOnInit(): void {
    this.columns = [

      {
        name: 'firstName',
        label: 'First Name',
        inputType: 'text',
        validators: [
          Validators.required
        ],
        errorMessages: {
          required: 'First Name is required'
        }
      },
      {
        name: 'lastName',
        label: 'Last Name',
        inputType: 'text',
        validators: [
          Validators.required
        ],
        errorMessages: {
          required: 'Last Name is required'
        },
      },
      {
        name: 'email',
        label: 'Email',
        inputType: 'email',
        validators: [
          Validators.required,
          Validators.email
        ],
        asyncValidators: [
          existsValidator(this.userService)
        ],
        updateOn: 'blur',
        errorMessages: {
          required: 'Email is required',
          email: 'Please enter a valid email address',
          exists: 'A user with this email address already exists'
        }
      } ,
      {
        name: 'rolesArray',
        label: 'Roles',
        inputType: 'checkbox-list',
        options: [
          { value: 'Admin', label: 'Admin' },
          { value: 'Editor', label: 'Editor' }
        ]
      },
    ]
    super.ngOnInit();
  }

  protected override getColumnsForCreate(): ColumnConfig[] {
    return [...this.columns, this.createPasswordColumn];
  }

  protected override getAsyncValidatorsForEdit(column: ColumnConfig, itemId: number): AsyncValidatorFn[] {
    if (column.name === 'email') {
      return [existsValidator(this.userService, itemId)];
    }
    return [];
  }


}
